export default "__VITE_ASSET__CNPpAlhQ__"